import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sm/wds-react';
import { IconChevronDown, IconChevronUp } from '@sm/wds-icons';
import classNames from 'classnames';
import { NavBarAnonContext } from '../NavBarAnonContext.js';

import SMHeaderContext from '../../../SMHeaderContext.js';

export const Menu = ({ path, title, menuKey, children, name }) => {
  const { color, submenuOpened, toggleSubmenu } = useContext(NavBarAnonContext);
  const { excludeMenuItems } = useContext(SMHeaderContext);

  const linksClassname = classNames(
    `sm-header__nav-cta--${color}`,
    'sm-header__text',
    { 'sm-header--open': submenuOpened === menuKey }
  );

  if (excludeMenuItems.includes(name)) return null;

  return (
    <>
      {path === '' ? (
        <div className="wds-display--inline-block" key={menuKey}>
          <Button
            variant="text"
            className={linksClassname}
            color={color}
            onClick={() => toggleSubmenu(menuKey)}
          >
            {title}
            <>
              {submenuOpened === menuKey ? (
                <IconChevronUp size="xs" />
              ) : (
                <IconChevronDown size="xs" />
              )}
            </>
          </Button>
          {children}
        </div>
      ) : (
        <Button
          key={menuKey}
          variant="text"
          color={color}
          href={path}
          className={`sm-header__nav-cta--${color} sm-header__text`}
        >
          {title}
        </Button>
      )}
    </>
  );
};

Menu.propTypes = {
  path: PropTypes.string,
  title: PropTypes.string.isRequired,
  menuKey: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
};
Menu.defaultProps = {
  path: '',
};

export default Menu;
